module.exports = __webpack_public_path__ + "img/b05.7917afb5.png";